export const ROUTES = {
  ROOT: '/',
  JOBS: '/jobs',
  LOGIN: '/login',
  SIGNUP: '/signup',
  AGENCY_REGISTRATION: '/agency_registration',
  INVITE_REGISTRATION: '/invite_registration',
  UNAUTHENTICATED: '/unauthenticated-checkin',
  NOT_FOUND: '/not_found',
  SEND_VERIFICATION: '/send_verification',
  FORGOT_PASSWORD: '/forgot_password',
  RESET_PASSWORD: '/reset_password',
  REGISTRATION: '/registration',
  MINOR_ADD_MEMBER: '/registration/minor/add_member',
  MINOR_MEMBER_INFO: '/registration/minor/member_info',
  MINOR_PROFILE_IMAGE: '/registration/minor/profile_image',
  NEW_TALENT: '/new-talent',
  REDIRECT: '/go',
  DELETE_ACCOUNT: '/delete_account_confirmation',
  INITIATE_DELETE: '/intiate_delete',
  IMPERSONATION: '/impersonation',
  PUBLIC_PROFILE: '/:region',
  COMPLETE_PROFILE: '/complete_profile',
  DOWNLOAD: '/download',
  TALENT: {
    COMPLETE_CHECKIN: '/talent/complete-check-in',
    COMPLETE_ST: '/talent/complete-self-tapes',
    DASHBOARD: '/talent/dashboard',
    SETTINGS: '/talent/settings',
    PROFILES: '/talent/profiles',
    OPPORTUNITIES: '/talent/opportunities',
    CHECKIN: '/talent/check-in',
    SELFTAPES: '/talent/self-tapes',
    PAST_SELFTAPES: '/talent/past-self-tapes',
    MYINFO: '/talent/my_info',
    MEDIA: '/talent/media',
    // ATTENDED_AUDITIONS: '/talent/attended_auditions',
    // AUDITION_REQUEST: '/talent/audition_request',
    PREV_AUDITION_REQUEST: '/talent/prev_audition_request',
    // UPCOMING_AUDITIONS: '/talent/upcoming_auditions',
    AUDITIONS: '/talent/auditions',
    MYLINKS: '/talent/mylinks',
    CALENDAR: '/talent/calendar',
    REPRESENTATIVES: '/talent/representatives',
  },
  // MEDIA: {
  //   DASHBOARD: '/media/dashboard',
  //   IMAGES: '/media/images',
  //   VIDEOS: '/media/videos',
  //   AUDIOS: '/media/audios',
  //   DOCUMENTS: '/media/documents',
  // },
};
